import { render, staticRenderFns } from "./classic-container.vue?vue&type=template&id=488216ba&"
import script from "./classic-container.vue?vue&type=script&lang=js&"
export * from "./classic-container.vue?vue&type=script&lang=js&"
import style0 from "./classic-container.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports